import React from 'react';

function Header(props) {
    return (
        <div className="page-header">
            <h1 className="page-title">Dashboard</h1>
            <div>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a >Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Dashboard</li>
                </ol>
            </div>
        </div>
    );
}

export default Header;